"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcFormFieldBadge = void 0;
var react_1 = __importDefault(require("react"));
var Badge_1 = __importDefault(require("react-bootstrap/Badge"));
var AcFormFieldBadge = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'md' : _b, _c = _a.type, type = _c === void 0 ? 'required' : _c;
    var badgeTypes = {
        required: {
            variant: 'attention',
            text: '必須',
        },
        optional: {
            variant: 'success',
            text: '任意',
        },
        outputFormat: {
            variant: 'apzashdarkblue',
            text: '出力形式',
        },
        editable: {
            variant: 'apzashblue',
            text: '編集可',
        },
        nonEditable: {
            variant: 'apzashblue',
            text: '編集不可',
        },
    };
    var badgeStyles = {
        paddingTop: '3px',
        paddingBottom: '3px',
        paddingLeft: '5px',
        paddingRight: '5px',
    };
    // if (size === 'sm') {
    //   badgeStyles.padding = '1px 4px';
    // }
    return (react_1.default.createElement(Badge_1.default, { variant: type ? badgeTypes[type].variant : undefined, className: "fs-minimum font-weight-bold", style: badgeStyles }, type && badgeTypes[type].text));
};
exports.AcFormFieldBadge = AcFormFieldBadge;
exports.AcFormFieldBadge.displayName = 'AcFormFieldBadgeProps';
//# sourceMappingURL=AcFormFieldBadge.js.map